import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-container" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "body-text-bold" }

import __ from '@/translate';

export default /*@__PURE__*/_defineComponent({
  __name: 'NotFoundComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(__)('not_found_title')), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(__)('not_found_subtitle')), 1)
  ]))
}
}

})